import EnteteImpressionHelperController from './entete.impression.helper.controller';

export default {
	bindings: {
		modalInstance: '<'
	},
	template: require('./entete.impression.helper.html'),
	controller: EnteteImpressionHelperController
};
